export default __webpack_public_path__ + "static/media/Neet-Exam.c19788a5.png";